<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId">
        <el-select v-model="queryParams.userId" filterable clearable placeholder="代理商" @change="search">
          <el-option v-for="(item,index) in agentList" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="iccid">
        <el-input v-model="queryParams.iccid" clearable placeholder="ICCID/ICCIDS空格隔开"></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="handleInternationalCustomizeCardProduct"   v-hasPermi="['international:card:product:add']">批量添加</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" ref="tableData" border @sort-change="tableSortChange" @selection-change="handleSelectionChange" v-loading="loading">
      <el-table-column type="selection" align="center"></el-table-column>
      <el-table-column prop="agentName" label="代理商" align="center" width="260px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" sortable="custom" align="center" min-width="200px" fixed>
        <template slot-scope="{row}">
          <el-link type="success" :underline="false" @click='jumpButton(row.iccid)'>{{row.iccid}}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="msisdn" label="MSISDN" align="center" min-width="140px"></el-table-column>
      <el-table-column prop="showStatus" label="展示状态" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="row.showStatus =='已激活'">{{row.showStatus}}</el-tag>
            <el-tag v-else-if="row.showStatus =='库存'" type="success">{{row.showStatus}}</el-tag>
            <el-tag v-else-if="row.showStatus =='已停机'" type="danger">{{row.showStatus}}</el-tag>
            <el-tag v-else-if="row.showStatus =='待激活'" type="info">{{row.showStatus}}</el-tag>
            <el-tag v-else type="warning">{{row.showStatus}}</el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="monthFlow" label="月流量" align="center" sortable="custom"  width="100px"></el-table-column>
      <el-table-column prop="cardSourceName" label="卡源" align="center"></el-table-column>
      <el-table-column  label="可购套餐" align="center" width="200px">
        <span  slot="header">
            <el-tooltip content="查看卡可使用区域以及使用区域的套餐价格" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
              限制区域和套餐价格
        </span>
        <template slot-scope="{ row }">
          <div class="product-list">
            <div class="product-item" v-for="(item,index) in selectInternationalCardProductInfo(row)" :key="index" :title="item">
                  <span>{{item.groupName}}</span>
            </div>
            <span class="el-dropdown-link"  @click="showMoreCountry(row)">
              <i class="el-icon-d-arrow-right el-icon--right"></i>更多
            </span>
          </div>
          
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="260px" fixed="right">
        <template slot-scope="{ row }">
          <el-button size="mini" type="warning" plain icon="el-icon-delete" v-hasPermi="['international:card:product:remove']" @click="removeCardProduct(row)">移除卡片</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
    <el-dialog title="区域价格列表" :visible.sync="productOpen" width="1000px" append-to-body :close-on-click-modal="false">
      <el-input placeholder="请输入内容" v-model="searchQuery" clearable style="width: 30%"></el-input>
      <el-table :data="filteredProductData" height="650"  style="width: 100%">
        <el-table-column prop="id" label="套餐ID" align="center"></el-table-column>
        <el-table-column prop="productName" label="套餐名称" :show-overflow-tooltip="true" align="center"></el-table-column>
        <el-table-column label="套餐类型" align="center" prop="status" width="80">
          <template slot-scope="scope">
            <el-tag>{{transferProductType(scope.row.type)}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="validate" label="套餐周期（天）" align="center"></el-table-column>
        <el-table-column prop="groupName" label="限制区域" :show-overflow-tooltip="true" align="center"></el-table-column>
        <el-table-column prop="price" label="套餐价格" align="center"></el-table-column>
        <el-table-column prop="currency" label="支付币种" align="center"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { agentList } from "@/api/api.js"; //获取代理商下拉列表
import { selectInternationalCardProductList,selectInternationalCardProduct , removeInternationalCardProduct} from "@/api/international.js";

export default {
  name:"internationalCardProduct",
  data() {
    return{
      //遮罩层
      loading: true,
      queryParams:{
        riskControl:'1'
      },
      tableData:[],
      dateRange: [],
      folding:false,
      // 排序方式
      sortOrder: "",
      // 排序名称
      sortName: "",
      page: 1,
      pageSize: 10,
      total:0,
      agentList: [],
      productOpen:false,
      searchQuery:'',
      cardProductData:[]
    }
  },
  watch: {
    '$route': {
      handler: function (to, from) {
        if (to.name == "internationalCardProduct") {
            this.initData();
        }
      },
      deep: true,
    },
  },
  computed:{
    filteredProductData() {
      return this.cardProductData.filter(row => {
        return Object.values(row).some(value => {
          return String(value).toLowerCase().includes(this.searchQuery.toLowerCase());
        });
      });
    }
  },
  methods: {
    transferProductType(status) {
      let obj = {
        1: "累计套餐",
        2: "月套餐",
        3: "加油包套餐",
        4: "停机保号套餐",
        5: "补卡套餐",
        6: "加速包套餐",
        7: "测试套餐",
        8: "赠送套餐",
        9: "发票套餐",
        10: "流量池加油包"
      };
      return obj[status];
    },
    // 获取列表的数据
    initData(){
      let params = {
        model:{
          ...this.addDateRange(this.queryParams, this.dateRange),
          order: this.sortOrder,
          sort: this.sortName,
        },
        
        page: this.page,
        pageSize: this.pageSize
      }
      this.loading = true;
      selectInternationalCardProductList(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
        this.loading = false;
      })
    },
    tableSortChange(val){
      this.sortOrder = val.order === "descending" ? "desc" : "asc";
      if(val.prop == 'monthFlow'){
        this.sortName = 'monthFlow'
      }
      if(val.prop == 'lastOpenTime'){
        this.sortName = 'lastOpenTime'
      }
      if(val.prop == 'lastRechargeTime'){
        this.sortName = 'lastRechargeTime'
      }
      if(val.prop == 'closeTime'){
        this.sortName = 'closeTime'
      }
      if(val.prop == 'iccid'){
        this.sortName = 'iccid'
      }
      this.initData()
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.sortOrder = '';
      this.sortName = '';
      this.$refs.tableData.clearSort();
      this.resetForm("queryForm");
      this.queryParams = {riskControl:'1'};
      this.search();
    },
    
    //代理商下拉列表
    queryAgentList() {
      agentList().then(res => {
        this.agentList = res.data.data;
      });
    },
    // 多选单选的值
    handleSelectionChange(selection){
      this.ids = selection.map(item => item.id);
      this.single = selection.length!=1;
      this.multiple = !selection.length;
    },
    //批量添加自定义套餐
    handleInternationalCustomizeCardProduct(){
        this.$router.push("/internationalCustomizeCardProduct/add");
    },
    jumpButton(iccid){
      this.$router.push({path:"/card/detail",query:{iccid: iccid}});
    },
    //查询卡限制区域以及区域的套餐价格
    selectInternationalCardProductInfo(row){
      selectInternationalCardProduct({iccid:row.iccid}).then(res=>{
        row.cardProductData = res.data.data
        return res.data.data
      })
    },
    showMoreCountry(row){
      this.productOpen = true;
      this.cardProductData = row.cardProductData;
    },
    //移除卡限制区域以及套餐
    removeCardProduct(row){
      this.$confirm('是否确认删除此卡的区域和套餐？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let iccid = row.iccid
          removeInternationalCardProduct({iccid}).then(res=>{
            this.$message({type: 'success',message: '移除成功'});
            this.initData()
          })
        }).catch(() => {});
      
    }
  },
  mounted() {

  },
  created() {
    this.queryAgentList();
    this.initData()
  }
};
</script>
<style scoped lang="less">
</style>
